import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Horse_show } from '../../models/horse_show';
import { Horse_show_entry } from '../../models/horse_show_entry';
import { Checkout_request_summary } from '../../models/accounting/checkout_request_summary';
import { Bill_item } from '../../models/accounting/bill_item';
import { Braintree_credit_card } from '../../models/accounting/banking/braintree_credit_card';
import { Bambora_credit_card } from '../../models/accounting/banking/bambora_credit_card';
import { CheckoutService } from '../../providers/checkout.service';
import { CheckoutRequestService } from '../../providers/checkout-request.service';
import { BraintreeService } from '../../providers/braintree.service';
import { SubmitEntriesService } from '../../providers/submit-entries.service';
import { RefundPolicyService } from '../../providers/refund-policy.service';

import { faCashRegister,faCreditCard, faShareAlt, faSpinner, faPlus, faUser, faArrowRight, faDotCircle } from '@fortawesome/pro-regular-svg-icons';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import {HorseShowService} from '../../providers/horse-show.service';

@Component({
  standalone: false,
  selector: 'app-submit-entries',
  templateUrl: './submit-entries.component.html',
styleUrls:  ['./submit-entries.component.css']
})
export class SubmitEntriesComponent extends SmsAbstractAppPage implements OnInit {
	faCreditCard = faCreditCard;
	faCashRegister = faCashRegister;
	faShareAlt = faShareAlt;
	faSpinner = faSpinner;
	faPlus = faPlus;
	faUser = faUser;
	faArrowRight = faArrowRight;
  faDotCircle = faDotCircle;
  device_data: string = "";

	refund_policy_text: string = '';

	horse_show: Horse_show = null;
	checkout_request_summary: Checkout_request_summary = null;
	selected_credit_card: any = {};
  selected_bambora_card: Bambora_credit_card = null;

  is_loading: boolean = false;

  is_submitted: boolean = false;

  additional_terms_agreed: boolean = false;

  constructor(private router: Router,
    private horseShowService: HorseShowService,
  	private checkoutService: CheckoutService,
  	private checkoutRequestService: CheckoutRequestService,
  	private refundPolicyService: RefundPolicyService,
  	private submitEntriesService: SubmitEntriesService,
    private braintreeService: BraintreeService) {
  	super();
  }

  ngOnInit() {

  	this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

  	this.checkoutService.getHorse_show().subscribe(horseShowView => {

  		if(horseShowView.horseShowId != undefined){

        this.horseShowService.get(horseShowView.horseShowId).then((horseShow) => {

          this.horse_show = horseShow;

          if(this.horse_show.id != undefined){

            this.checkoutService.getHorse_show_entry_list().subscribe(horse_show_entry_list => {

              const entry_id_list: string[] = [];
              horse_show_entry_list.forEach(entry => {
                entry_id_list.push(entry.entryId);
              });

              this.is_loading = true;
              this.checkoutRequestService.getCheckoutRequest(this.horse_show.id, entry_id_list).then(checkout_request_summary => {
                this.checkout_request_summary = checkout_request_summary;

                this.is_loading = false;
              }).catch(error => {
                this.handleError(error);
              });

            }, error =>{
              this.handleError(error);
            });

            this.refundPolicyService.getRefundPolicyHtml(this.horse_show.id, this.horse_show.competition_organizer_id).then(html => {
              this.refund_policy_text = html;
            }).catch(error => {
              this.handleError(error);
            });

          }

        });

	  	} else {
	  		//NAVIGATE TO 'MY ENTRIES (SHOPPING CART VIEW)'
      		this.router.navigate(['my-entries']);
	  	}
  	}, error =>{
  		this.handleError(error);
  	});

    this.braintreeService.getDeviceData().then(dd => {
        this.device_data = dd;
      }).catch(error => {
        this.handleError(error);
      });

  }

  handleSubmitEntries(){

    if(this.horse_show.has_additional_terms && this.additional_terms_agreed == false){
      this.handleError("You must agree to the additional terms for entry at this event in order to submit entries!");
      return;
    }

    //Assemble list of selected entry IDs
    let entry_id_list: string[] = [];
    let additional_item_list: Bill_item[] = [];
    this.checkout_request_summary.checkout_request_entry_list.forEach((entry, i) => {
      entry_id_list.push(entry.entry_id);

      //Additional items account for the organizer adding a "Credit card convenience fee" onto the entry at time of checkout
      if(entry.additional_items && entry.additional_items.length >0){
        entry.additional_items.forEach((item, i)=>{
          additional_item_list.push(item);
        });
      }
    });

    this.is_submitted = true;

    if(this.horse_show.payment_gateway == 'BRAINTREE'){
      this.submitEntriesService.submitHorseShowEntries(this.selected_credit_card.token,
        this.selected_credit_card.customer_id,
        this.checkout_request_summary.total_amount,
        this.horse_show.id,
        entry_id_list,
        additional_item_list,
        this.device_data).then(receipt => {
          this.checkoutService.setSubmitted_entries_receipt(receipt);
          this.router.navigate(['entries-receipt']);
        }).catch(error => {
        	this.is_submitted = false;
          this.handleError(error);
        });
    } else if(this.horse_show.payment_gateway == 'STRIPE'){
      this.submitEntriesService.submitHorseShowEntriesStripe(this.selected_credit_card.stripe_id,
        this.checkout_request_summary.total_amount,
        this.horse_show.id,
        entry_id_list,
        additional_item_list,
        this.device_data).then(receipt => {
          this.checkoutService.setSubmitted_entries_receipt(receipt);
          this.router.navigate(['entries-receipt']);
        }).catch(error => {
          this.is_submitted = false;
          this.handleError(error);
        });
    } else if (this.horse_show.payment_gateway == 'BAMBORA') {
      if (!this.selected_bambora_card?.system_payment_method_id) {
        this.handleError('Please select a payment method before submitting.');
        this.is_submitted = false;
        return;
      }
      this.submitEntriesService.submitHorseShowEntriesCanada(
        this.selected_bambora_card.system_payment_method_id,
        this.checkout_request_summary.total_amount,
        this.horse_show.id,
        entry_id_list,
        additional_item_list).then(receipt => {
          this.checkoutService.setSubmitted_entries_receipt(receipt);
          this.router.navigate(['entries-receipt']);
        }).catch(error => {
          this.is_submitted = false;
          this.handleError(error);
        });
    } else {
      this.handleError("Payment gateway not supported!");
    }
  }

  handlePayByCheque(){
    if(this.horse_show.has_additional_terms && this.additional_terms_agreed == false){
      this.handleError("You must agree to the additional terms for entry at this event in order to submit entries!");
      return;
    }

    //Assemble list of selected entry IDs
    let entry_id_list: string[] = [];

    this.checkout_request_summary.checkout_request_entry_list.forEach((entry, i) => {
      entry_id_list.push(entry.entry_id);
    });

    this.is_submitted = true;

    this.submitEntriesService.submitHorseShowEntriesWithChequePledge(
        this.checkout_request_summary.total_amount,
        this.horse_show.id,
        entry_id_list).then(receipt => {
          this.checkoutService.setSubmitted_entries_cheque_receipt(receipt);
          this.router.navigate(['entries-cheque-receipt']);
        }).catch(error => {
          this.is_submitted = false;
          this.handleError(error);
        });

  }

  handleSelectPaymentMethod(card: any){
    this.selected_credit_card = card;
  }

  handleSelectBamboraPaymentMethod(card: Bambora_credit_card) {
    this.selected_bambora_card = card;
  }

  handleCreditCardError(error: string){
    this.handleError(error);
  }

  handleSubmitEntriesWithoutPayment(){
    if(this.horse_show.has_additional_terms && this.additional_terms_agreed == false){
      this.handleError("You must agree to the additional terms for entry at this event in order to submit entries!");
      return;
    }

    //Assemble list of selected entry IDs
    let entry_id_list: string[] = [];
    let additional_item_list: Bill_item[] = [];
    this.checkout_request_summary.checkout_request_entry_list.forEach((entry, i) => {
      entry_id_list.push(entry.entry_id);

      //Additional items account for the organizer adding a "Credit card convenience fee" onto the entry at time of checkout
      if(entry.additional_items && entry.additional_items.length >0){
        entry.additional_items.forEach((item, i)=>{
          additional_item_list.push(item);
        });
      }
    });

    this.is_submitted = true;

    const submitFn = this.horse_show.country_iso_3 === 'CAN'
      ? this.submitEntriesService.submitHorseShowEntriesCanadaWithoutPayment.bind(this.submitEntriesService)
      : this.submitEntriesService.submitHorseShowEntriesWithoutPayment.bind(this.submitEntriesService);

    submitFn(this.checkout_request_summary.total_amount,
      this.horse_show.id,
      entry_id_list,
      additional_item_list).then(receipt => {
        this.checkoutService.setSubmitted_entries_receipt(receipt);
        this.router.navigate(['entries-receipt-without-payment']);
      }).catch(error => {
        this.is_submitted = false;
        this.handleError(error);
      });
  }

}
